import { KeyboardSensor, PointerSensor, TouchSensor, useSensor, useSensors } from "@dnd-kit/core";
import { sortableKeyboardCoordinates } from "@dnd-kit/sortable";
import { useServicesUIStore } from "../store/use-services-ui-store";

interface UseDragSensorsProps {
  isMobile: boolean;
}

export function useDragSensors({ isMobile }: UseDragSensorsProps) {
  const { searchTerm } = useServicesUIStore();

  // Drag and drop sensors - both defined unconditionally, then selected based on isMobile
  const touchSensor = useSensor(TouchSensor);
  const pointerSensor = useSensor(PointerSensor);
  const keyboardSensor = useSensor(KeyboardSensor, {
    coordinateGetter: sortableKeyboardCoordinates,
  });
  const sensors = useSensors(isMobile ? touchSensor : pointerSensor, keyboardSensor);

  // Disable drag sensors when searching
  const dragSensors = searchTerm.trim() ? [] : sensors;

  return dragSensors;
}
